import { render, staticRenderFns } from "./file-question.vue?vue&type=template&id=35e5a4e8"
import script from "./file-question.vue?vue&type=script&lang=js"
export * from "./file-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports